@import "../../global/visualization-base.scss";

:host {
  display: block;
}

.chart {
  &__wrapper {
    width: max-content;
  }

  &__svg {
    width: 100%;

    &--hoverable-line {
      stroke: transparent;
      stroke-width: 30px;
      fill: none;
      pointer-events: auto;
    }
  }

  &__axis {
    line {
      @include grid-lines;
    }

    &--hidden {
      path {
        @include invisible;
      }

      line {
        @include grid-lines;
      }
    }
  }
  
  &-text-label {
    &-start {
      text-anchor: start !important; // ! to override the host
    }
  }

  &__target-line {
    stroke-width: 2;
    stroke-dasharray: 3 2;
  }

  
  &__legend {
    &--flex {
      &-centre {
        display: flex;
        align-items: center;
        justify-content: center;
        column-gap: 20px;
        margin-top: 20px;
      }

      &-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }

    &--dot {
      @include legend-dot;
      margin-bottom: var(--uui-dv-default-margin-bottom);
    }

    &-line {
      width: 12px;
      height: 12px;
      margin-right: 0.5rem;
      margin-bottom: var(--uui-dv-default-margin-bottom);
      
      &--dashed {
        stroke-width: 2;
        stroke: var(--uui-color-dataviz-magenta);
        stroke-dasharray: 3 2;
        fill: none;
      }
    }
  }

  &__tooltip {
    @include tooltip;

    &--marker {
      stroke: var(--uui-dv-default-color);
      stroke-width: 1px;
      stroke-dasharray: none;
  
      &-dot {
        fill: var(--uui-dv-default-color);
      }
    }

    &--container {
      pointer-events: none;

      .chart__legend--flex-centre {
        margin-top: 0px;

        .chart__legend--flex-row:last-child {
          .uui-dv-legend-label, 
          .chart__legend-line,
          .chart__legend--dot {
            margin-bottom: 0;
          }
        }
      }
    }

    &--label {
      display: flex;
      align-items: center;
    }
  }

  &--hidden {
    display: none;
  }
}